import ReactModal from "react-modal";
import React, { useEffect, useState } from "react";

interface IModal {
    isOpen: boolean,
    children: string | JSX.Element | JSX.Element[],
    modalClosed: Function
}

const customStyles = {
    overlay: {
        zIndex: 1000,
        backgroundColor: 'rgba(1, 1, 1, 0.25)'
    },
};

export default function Modal({ isOpen, children, modalClosed }: IModal) {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        setOpen(isOpen);
    }, [isOpen]);

    function closeModal() {
        setOpen(false);
        modalClosed();
    }


    return (
        <ReactModal isOpen={open}
            contentLabel="Minimal Modal Example"
            className="modal"
            shouldCloseOnOverlayClick={true}
            style={customStyles}
            onRequestClose={() => closeModal()}>
            {children}
        </ReactModal>
    );
}